import React from 'react';

import { Button } from '@components/common';

import styles from './NavigateButtons.module.scss';

interface INavigateButtonsProps {
	closeText?: string;
	disabledNext?: boolean;
	nextText?: string;
	tooltipNext?: string;
	onCloseHandler?: () => void;
	onNextHandler?: () => void;
}

const NavigateButtons = ({
	closeText = 'Cancel',
	disabledNext = false,
	nextText = 'Next',
	onCloseHandler,
	onNextHandler,
	tooltipNext,
}: INavigateButtonsProps) => (
	<div className={styles.navigateButtonsContainer}>
		<Button
			onClick={onCloseHandler}
			text={closeText}
			withoutBackground
		/>
		<Button
			disabled={disabledNext}
			onClick={onNextHandler}
			text={nextText}
			tooltip={tooltipNext}
		/>
	</div>
);

export default NavigateButtons;
